import React, { useState } from "react"
import "./faqPartner.scss"

const FAQS = [
  {
    q: "How do I register as a cab driver or fleet partner with Pulpit?",
    a: "Fill out the registration form on this page with your details, fleet size, city, and vehicle types. Our team verifies your documents, completes a 30-minute onboarding walkthrough, and activates you on the platform - typically within 24-48 hours.",
  },
  {
    q: "What documents are required for partner registration?",
    a: "Drivers need a valid commercial driving license, Aadhaar card, PAN card, vehicle RC, commercial insurance, PUC certificate, fitness certificate, and All India Tourist Permit or valid state outstation permit. Fleet owners additionally need GST registration (mandatory for TDS), company registration, and authorization letters for each vehicle.",
  },
  {
    q: "How does the platform fee work?",
    a: "Pulpit collects the full fare from the customer and deducts a platform fee before transferring the net amount to your bank. Toll and parking charges are collected from the customer at actuals and passed through to you in full. Performance incentives can further improve your earnings.",
  },
  {
    q: "When and how do I receive my payouts?",
    a: "Payouts follow a weekly cycle. Monday to Sunday trips are settled every Tuesday via NEFT/IMPS to your registered bank account. A detailed payout statement is emailed and available on your Partner Dashboard. Minimum payout threshold is ₹500.",
  },
  {
    q: "What performance incentives are available?",
    a: "Partners with 90%+ acceptance rate get better incentives that month. Completing 50+ trips/month unlocks an additional volume bonus. Partners averaging 4.7+ customer rating receive monthly rewards. During festival seasons, customer fares surge and your earnings increase proportionally.",
  },
  {
    q: "What types of vehicles can I attach to Pulpit?",
    a: "We accept Hatchbacks, Sedans, SUVs, and Innova/MUV category vehicles. Your vehicle must be not older than 8 years, in good condition with working AC, valid commercial insurance, and All India Tourist Permit. Vehicle photos (front, back, interior) are required during onboarding.",
  },
  {
    q: "Who handles the customer - Pulpit or the partner?",
    a: "Pulpit handles all customer acquisition, marketing, fare setting, booking, dispatch, payment collection, and pre/post trip customer support. You handle the trip execution - your vehicle, your driver, fuel, toll, and parking. It's a clean split.",
  },
  {
    q: "Can fleet owners attach multiple vehicles to Pulpit?",
    a: "Yes, fleet owners and travel companies with 1 to 200+ own registered commercial vehicles can partner. You'll get a dedicated fleet account with Partner Dashboard access, vehicle and driver management, and a dedicated fleet support team for onboarding.",
  },
  {
    q: "Which cities and routes does Pulpit operate in?",
    a: "Pulpit operates across 450+ cities PAN-India with a focus on outstation routes. Priority regions include Delhi NCR, Maharashtra (Mumbai, Pune, Nashik), Gujarat (Ahmedabad, Surat, Vadodara), Karnataka (Bangalore, Mysuru), Rajasthan (Jaipur, Udaipur), UP (Lucknow, Agra, Varanasi), and Tamil Nadu (Chennai, Coimbatore).",
  },
  {
    q: "Is there a trial period for new partners?",
    a: "Yes, new partners go through a 30-day trial with limited trip volume. During this period, we monitor acceptance rate, service quality, punctuality, and customer ratings. Post-trial, you're fully activated with trip allocation scaling based on fleet size and performance.",
  },
]

const FaqPartner = () => {
  const [openIndex, setOpenIndex] = useState(0)

  const toggle = (idx) => {
    setOpenIndex(openIndex === idx ? -1 : idx)
  }

  return (
    <section className="faq-partner">
      <div className="faq-partner__container">
        <h2 className="faq-partner__heading">
          Cab Driver Registration <span>FAQs</span>
        </h2>
        <p className="faq-partner__subheading">
          Common questions about joining as a cab driver or fleet owner
        </p>
        <div className="faq-partner__list">
          {FAQS.map((faq, i) => (
            <div
              className={`faq-partner__item ${openIndex === i ? "faq-partner__item--open" : ""}`}
              key={i}
            >
              <button
                className="faq-partner__question"
                onClick={() => toggle(i)}
                aria-expanded={openIndex === i}
              >
                <span>{faq.q}</span>
                <span className="faq-partner__icon">
                  {openIndex === i ? "−" : "+"}
                </span>
              </button>
              <div className="faq-partner__answer">
                <p>{faq.a}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default FaqPartner
